module.exports = __webpack_public_path__ + "static/media/RemedyBilling.74eef5fd.png";